import React from "react";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import "./food-and-beverages.css";
import KeyChallenges from "./KeyChallenges";
import KeyFeatures from "./KeyFeatures";
import HowItWorks from "./HowItWorks";
import TechnologyStack from "./TechnologyStack";
import CallToAction from "./CallToAction";
import Benefits from "./Benefits";

const FoodAndBeverages = () => {
  return (
    <div className="food-and-beverages-industry-wrapper">
      <Particles title="Food & Beverages" />
      <HeroSection />
      <KeyChallenges />
      <KeyFeatures />
      <Benefits />
      <HowItWorks />
      <TechnologyStack />
      <CallToAction />
    </div>
  );
};

export default FoodAndBeverages;
